<template>
    <div class="outer">
        <swipe class="intro-swipe">
            <swipe-item class="intro_iphone_remote_control" alt="iPhone remote control"></swipe-item>
            <swipe-item class="intro_iphone_trackpad_ipad_remote_control" alt="iPhone trackpad and iPad remote control"></swipe-item>
            <swipe-item class="intro_iphone_keyboard" alt="iPhone keyboard"></swipe-item>
            <swipe-item class="intro_apple_watch_trackpad" alt="Apple Watch trackpad"></swipe-item>
        </swipe>
    </div>
</template>

<script>
    import { Swipe, SwipeItem } from 'vue-swipe'

    export default {
        components: {
            Swipe, SwipeItem
        }
    }
</script>

<style>
    @import '../../node_modules/vue-swipe/dist/vue-swipe.css';

    .intro-swipe {
        height: 500px;
        font-size: 10px;
    }

    .intro_iphone_remote_control {
        background: url('../assets/images/intro_iphone_remote_control.jpeg') no-repeat center;
        background-size: contain;
    }

    .intro_iphone_trackpad_ipad_remote_control {
        background: url('../assets/images/intro_iphone_trackpad_ipad_remote_control.jpeg') no-repeat center;
        background-size: contain;
    }

    .intro_iphone_keyboard {
        background: url('../assets/images/intro_iphone_keyboard.jpeg') no-repeat center;
        background-size: contain;
    }

    .intro_apple_watch_trackpad {
        background: url('../assets/images/intro_apple_watch_trackpad.jpeg') no-repeat center;
        background-size: contain;
    }
</style>



// WEBPACK FOOTER //
// src/components/IntroSwipe.vue